var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_19534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8946 10.6621C23.4119 10.6621 23.6279 9.99749 23.2077 9.69113L16.8143 5.04046C16.723 4.97356 16.6127 4.9375 16.4995 4.9375C16.3864 4.9375 16.2761 4.97356 16.1848 5.04046L9.7914 9.69113C9.3712 9.99582 9.58716 10.6621 10.1061 10.6621H11.1424V16.9233H9.93705C9.86338 16.9233 9.80312 16.9835 9.80312 17.0572V17.9277C9.80312 18.0014 9.86338 18.0617 9.93705 18.0617H23.062C23.1357 18.0617 23.196 18.0014 23.196 17.9277V17.0572C23.196 16.9835 23.1357 16.9233 23.062 16.9233H21.8567V10.6621H22.8946ZM16.4995 6.2207L21.0381 9.52204H11.961L16.4995 6.2207ZM12.3478 10.6621H14.3065V16.9233H12.3478V10.6621ZM15.5118 10.6621H17.4705V16.9233H15.5118V10.6621ZM20.6513 16.9233H18.6759V10.6621H20.6513V16.9233Z",
    fill: "#344054"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_19534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(9 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.57a85a7850dc2160796f170867d0ba21.svg";
export { ForwardRef as ReactComponent };